module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.locale.t('label_tab_orders_reservation')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_from")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_to")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo width-four-fifths"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.clickSearch
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_do_search')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_picture")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_price")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_time_pickup")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_user")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_location")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_cancel")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(item.image != null && item.image.length > 0) ? _c('img', {
      staticClass: "cropped1 user-avatar-sm",
      attrs: {
        "src": item.image
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_price')
      }
    }, [_vm._v(_vm._s(item.amount) + " RSD\n                  " + _vm._s(item.discount != null && item.discount > 0 ? '(-' + item.discount.toFixed(0) + '%)' : '') + "\n                ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_time_pickup')
      }
    }, [_vm._v(_vm._s(_vm.formatDateAndTime(item.reservedFor)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_user')
      }
    }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_location')
      }
    }, [_vm._v("\n                  " + _vm._s(item.location == null || item.location.length === 0 ? '/' : item.location) + "\n                ")]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_cancel')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.cancelOrder(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_cancel')) + "\n                  ")])])])
  }), 0)])])])]), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48144f3b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/OrdersReservation.vue
// module id = 755
// module chunks = 0